/* PETCHEFY — Terms & Conditions (terms-v2). Vanilla JS, no deps. Renders into
   [data-terms2-root] from the [data-terms2-config] JSON blob (same architecture as
   faq-v2.js / nutrition-assistant.js) and binds: sticky TOC with scrollspy + search
   highlighting, reading-progress bar, section deep links + copy-link, back-to-top.

   CONTENT SOURCE: "PETCHEFY TERMS AND CONDITIONS.docx", effective July 22, 2026.
   Legal copy is transcribed verbatim — do not paraphrase when editing. The SECTIONS
   array below is the single source of truth for the page's text. */
(function () {
  'use strict';

  var root = document.querySelector('[data-terms2-root]');
  var cfgEl = document.querySelector('[data-terms2-config]');
  if (!root) return;

  var CFG = {};
  if (cfgEl) { try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { CFG = {}; } }
  var A = CFG.assets || {};
  var S = CFG.settings || {};

  var CTA_URL = S.ctaUrl || '/pages/build-my-plan';
  var LOGIN_URL = S.loginUrl || 'https://petchefy.com/apps/account';
  var FAQ_URL = S.faqUrl || '/pages/dog-food-plan?view=faq-v2';
  var PRIVACY_URL = S.privacyUrl || '/policies/privacy-policy';
  var REFUND_URL = S.refundUrl || '/policies/refund-policy';
  var EMAIL = S.supportEmail || 'hello@petchefy.com';
  var PHONE = S.supportPhone || '(954) 459-3168';
  var EFFECTIVE = S.effectiveDate || 'July 22, 2026';
  var SMS = 'sms:+19544593168';
  var TEL = 'tel:+19544593168';
  var LOGO = A.logo2 || A.logo || '';
  var SOCIAL = { instagram: 'https://instagram.com/petchefy', facebook: 'https://facebook.com/petchefy', tiktok: 'https://tiktok.com/@petchefy' };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* {sms}…{/} {email}…{/} {login}…{/} {cta}…{/} {faq}…{/} {privacy}…{/} {refund}…{/}
     {s5}…{/} → internal link to section 5. */
  function links(html) {
    return html
      .replace(/\{sms\}/g, '<a href="' + SMS + '">')
      .replace(/\{email\}/g, '<a href="mailto:' + esc(EMAIL) + '">')
      .replace(/\{login\}/g, '<a href="' + esc(LOGIN_URL) + '">')
      .replace(/\{cta\}/g, '<a href="' + esc(CTA_URL) + '">')
      .replace(/\{faq\}/g, '<a href="' + esc(FAQ_URL) + '">')
      .replace(/\{privacy\}/g, '<a href="' + esc(PRIVACY_URL) + '">')
      .replace(/\{refund\}/g, '<a href="' + esc(REFUND_URL) + '">')
      .replace(/\{s5\}/g, '<a href="#autoship" data-jump="autoship">')
      .replace(/\{s21\}/g, '<a href="#contact" data-jump="contact">')
      .replace(/\{\/\}/g, '</a>');
  }

  /* ============================== content ==============================
     Verbatim from PETCHEFY TERMS AND CONDITIONS.docx (effective 2026-07-22).
     Block types: p (paragraph) · ul (bullet list) · h3 (subsection) · call (callout)
     · rows (contact buttons) · address (contact card). */

  var SECTIONS = [
    {
      n: '1', id: 'agreement', title: 'Agreement to These Terms',
      blocks: [
        { p: 'These Terms and Conditions (“Terms”) are a legally binding agreement between you and PET CHEFY LLC, a Florida limited liability company operating the PETCHEFY brand (“PETCHEFY,” “we,” “us,” or “our”).' },
        { p: 'These Terms govern your access to and use of:' },
        { ul: [
          'The PETCHEFY website;',
          'PETCHEFY checkout and customer-account features;',
          'Questionnaires, feeding tools, meal-plan recommendations, and educational materials;',
          'PETCHEFY food, products, subscriptions, deliveries, and pickup services; and',
          'PETCHEFY customer support and other related services.'
        ] },
        { p: 'These are collectively referred to as the “Services.”' },
        { p: 'By creating an account, placing an order, selecting a subscription, clicking a button indicating your agreement, or otherwise using the Services after these Terms have been presented or linked to you, you agree to these Terms.' },
        { call: [
          'Do not use the Services or place an order if you do not agree to these Terms.',
          'You must be at least 18 years old and legally capable of entering into a binding agreement to create an account, place an order, or enroll in a subscription.'
        ] },
        { p: 'The following policies are incorporated into these Terms:' },
        { ul: [
          '{privacy}PETCHEFY Privacy Policy{/}',
          '{refund}PETCHEFY Refund Policy{/}'
        ] },
        { p: 'Any specific terms displayed for a product, promotion, or order at checkout are also incorporated into these Terms. For return and refund matters, the Refund Policy controls if it provides more specific terms.' }
      ]
    },
    {
      n: '2', id: 'accounts', title: 'Customer Accounts and Information',
      blocks: [
        { p: 'You agree to provide complete, accurate, and current account, contact, payment, delivery, and pet information.' },
        { p: 'You are responsible for maintaining the confidentiality of your account credentials and for activity conducted through your account. Notify PETCHEFY promptly if you believe your account or payment information has been accessed without authorization.' },
        { p: 'You represent that you are authorized to use every payment method submitted through your account.' },
        { p: 'You must promptly update changes to your:' },
        { ul: [
          'Email address or telephone number;',
          'Billing or delivery address;',
          'Payment method;',
          'Dog’s weight, age, activity level, or feeding needs;',
          'Dog’s allergies, sensitivities, medications, or medical conditions; and',
          'Subscription selections or delivery preferences.'
        ] },
        { p: 'PETCHEFY may rely on the information you provide when producing feeding recommendations, portion estimates, and meal plans. PETCHEFY is not responsible for consequences caused by materially inaccurate, incomplete, or outdated information supplied by you.' },
        { p: 'PETCHEFY products are sold for personal and household use. You may not resell, redistribute, relabel, alter, or commercially exploit PETCHEFY products without our prior written permission.' }
      ]
    },
    {
      n: '3', id: 'products', title: 'Products, Feeding Recommendations, and Pet Health',
      blocks: [
        { h3: '3.1 Products are intended for dogs' },
        { p: 'Unless a product expressly states otherwise, PETCHEFY food and related products are intended only for dogs. They are not intended for human consumption or for use with another animal species.' },
        { h3: '3.2 PETCHEFY does not provide veterinary care' },
        { p: 'PETCHEFY questionnaires, feeding recommendations, meal plans, educational content, and customer-support communications are provided for general nutritional and informational purposes.' },
        { call: [
          'They are <b>not veterinary medical advice, diagnosis, treatment, or emergency care</b> and do not create a veterinarian-client-patient relationship.'
        ] },
        { p: 'The fact that a PETCHEFY recipe or meal plan was developed, reviewed, or formulated with veterinary or animal-nutrition professionals does not mean that PETCHEFY is acting as your dog’s veterinarian.' },
        { p: 'Consult a licensed veterinarian before making a material dietary change, particularly if your dog:' },
        { ul: [
          'Is a puppy, senior, pregnant, or nursing;',
          'Has a diagnosed illness or medical condition;',
          'Has food allergies, digestive problems, or a history of adverse reactions;',
          'Takes medication or consumes a therapeutic veterinary diet; or',
          'Requires medical weight management.'
        ] },
        { p: 'Contact a veterinarian or emergency veterinary clinic immediately if your dog appears seriously ill or experiences a severe reaction. PETCHEFY customer support is not an emergency service.' },
        { h3: '3.3 Feeding recommendations are estimates' },
        { p: 'PETCHEFY feeding recommendations are estimates based on the information available to us. A dog’s actual needs may vary based on metabolism, health, age, body condition, activity, treats, other food intake, and veterinary guidance.' },
        { p: 'You are responsible for monitoring your dog’s weight, body condition, appetite, digestion, and overall health and for making appropriate feeding adjustments.' },
        { p: 'A topper, supplemental portion, or partial-feeding plan may need to be served with another complete and balanced food. Do not assume that a selected serving constitutes your dog’s entire daily nutritional requirement unless the applicable product label or meal plan expressly states that it does.' },
        { h3: '3.4 Ingredients and allergies' },
        { p: 'Review the current ingredient list and product label before serving every PETCHEFY product.' },
        { p: 'Do not assume that a product is free from a particular ingredient, allergen, or possible cross-contact unless PETCHEFY expressly states that it is.' },
        { p: 'Recipes, ingredients, suppliers, nutritional information, packaging, and serving instructions may be updated. The information printed on the current product packaging controls over older website content, advertisements, photographs, or prior recipe descriptions.' },
        { p: 'PETCHEFY will not knowingly replace an ordered recipe with a materially different primary protein without notifying you or receiving your approval. If a product is unavailable, PETCHEFY may delay the order, ask you to approve an alternative, or cancel and refund the unavailable item.' },
        { p: 'Stop feeding a product and consult your veterinarian if your dog experiences a suspected adverse reaction.' },
        { h3: '3.5 No guaranteed health outcome' },
        { p: 'Individual dogs respond differently to foods and dietary changes.' },
        { p: 'PETCHEFY does not guarantee that a dog will like a particular recipe or experience any particular medical, digestive, behavioral, weight, energy, coat, longevity, or veterinary-cost outcome.' },
        { p: 'Reviews, testimonials, before-and-after descriptions, and reported customer results reflect individual experiences and do not guarantee future results.' }
      ]
    },
    {
      n: '4', id: 'orders', title: 'Orders, Prices, and Payment',
      blocks: [
        { p: 'All orders are subject to acceptance, product availability, delivery-area limitations, payment authorization, and fraud review.' },
        { p: 'PETCHEFY may reject or cancel an order because of:' },
        { ul: [
          'Product unavailability;',
          'A pricing or product-description error;',
          'Payment failure;',
          'Suspected fraud or unauthorized activity;',
          'Suspected commercial resale;',
          'Safety concerns; or',
          'Circumstances that make fulfillment impracticable.'
        ] },
        { p: 'The prices, discounts, taxes, delivery charges, and other fees applicable to an order will be displayed before you submit the order.' },
        { p: 'By placing an order, you authorize PETCHEFY, Shopify, and the applicable payment processors to charge the payment method you provide for the amount displayed at checkout.' },
        { p: 'An order is not accepted until PETCHEFY confirms it and the payment has been successfully authorized or captured.' },
        { p: 'If PETCHEFY discovers a material pricing or product-description error, we may contact you for approval of the corrected order or cancel the affected item and issue a refund. PETCHEFY will not charge a higher corrected price without your authorization.' },
        { p: 'A customer-requested change to a recipe, quantity, portion, delivery frequency, or meal plan may change the price of future orders.' }
      ]
    },
    {
      n: '5', id: 'autoship', title: 'Autoship and Automatic Renewal',
      blocks: [
        { h3: '5.1 Autoship enrollment and consent' },
        { p: 'PETCHEFY offers both one-time purchases and Autoship, our automatically renewing subscription program.' },
        { p: 'When you select Autoship, Shopify checkout displays that the purchase is recurring and presents the applicable price, order frequency, and cancellation terms.' },
        { p: 'By selecting Autoship and completing checkout, you expressly authorize PETCHEFY and its payment processors to charge your selected payment method for:' },
        { ul: [
          'Your initial Autoship order; and',
          'Each recurring Autoship order at the price and frequency disclosed at checkout,'
        ] },
        { p: 'until you cancel Autoship.' },
        { p: 'Your Autoship plan continues automatically for successive billing and delivery periods. Unless a specific offer expressly states otherwise, there is no fixed commitment period and no cancellation fee.' },

        { h3: '5.2 How to cancel Autoship' },
        { p: 'You may cancel Autoship and stop future recurring charges by text, email, or any cancellation option displayed in your {login}PETCHEFY customer account{/}. Any clear and unambiguous statement that you want to cancel Autoship, stop Autoship, or stop future recurring orders is sufficient.' },
        { rows: true },
        { p: 'Any clear and unambiguous statement that you want to cancel or stop your PETCHEFY subscription is sufficient. You are not required to use a specific phrase, place a telephone call, speak with a retention representative, or provide a reason for canceling.' },
        { p: 'A request sent from the telephone number or email address associated with your PETCHEFY account is sufficient to identify the subscription. If you contact us from a different number or email address, include the customer name and the email address, phone number, or order number associated with the subscription.' },
        { p: 'A text or email is treated as received at the time it is delivered to the designated PETCHEFY number or email address, even if a PETCHEFY team member reads it later.' },
        { p: 'PETCHEFY will confirm a completed cancellation by text or email.' },

        { h3: '5.3 Cancellation cutoff and processed orders' },
        { p: 'To cancel, skip, pause, or modify the next recurring order, PETCHEFY must receive the request <b>before that order is processed</b>.' },
        { p: 'An order is considered processed when Shopify generates the recurring order and successfully authorizes or captures the recurring payment. The processing timestamp recorded in PETCHEFY’s Shopify order system determines whether a request was received before or after processing.' },
        { p: 'Processing may occur before the food is prepared, packed, dispatched, or delivered.' },
        { p: 'When PETCHEFY receives a cancellation request <b>before</b> processing:' },
        { ul: [
          'The upcoming recurring order will be canceled;',
          'No charge will be made for that upcoming order; and',
          'Future recurring charges will stop.'
        ] },
        { p: 'When PETCHEFY receives a cancellation request <b>after</b> processing:' },
        { ul: [
          'The processed order cannot be canceled;',
          'The charge for that processed order remains due;',
          'The processed order will ordinarily be prepared and delivered; and',
          'All later recurring charges and orders will stop.'
        ] },
        { p: 'A processed order is not refundable solely because the customer forgot to cancel, sent the request after processing, changed their mind, has excess food, or no longer needs the order. Any separate refund, credit, or replacement right is governed by the {refund}Refund Policy{/} and applicable law.' },

        { h3: '5.4 Pauses, skips, and account changes' },
        { p: 'Pausing or skipping an order does not cancel the subscription unless the confirmation expressly states that the subscription has been canceled.' },
        { p: 'Deleting an account, unsubscribing from marketing communications, declining a delivery, disputing an earlier charge, or removing an app does not by itself cancel a PETCHEFY subscription.' },
        { p: 'Changes received after an order has processed will apply to the next eligible recurring order.' },

        { h3: '5.5 Failed payments' },
        { p: 'If a recurring payment fails, PETCHEFY or its payment processor may retry the payment method, ask you to update your payment information, delay the order, suspend the subscription, or cancel the affected order or subscription.' },
        { p: 'PETCHEFY is not required to prepare or deliver an order for which payment has not been successfully authorized.' },
        { p: 'A cancellation request received before a later retry is successfully processed will stop future retry attempts and future recurring orders.' },

        { h3: '5.6 Autoship price changes' },
        { p: 'PETCHEFY may change subscription pricing prospectively by providing advance notice through email, text, your customer account, or another reasonable electronic method.' },
        { p: 'A price change will not apply retroactively to an order already processed.' },
        { p: 'When required by applicable law, PETCHEFY will provide the legally required notice period or obtain additional consent before applying a material change.' },
        { p: 'You may cancel before a new subscription price takes effect.' }
      ]
    },
    {
      n: '6', id: 'delivery', title: 'Delivery, Pickup, and Perishable Food',
      blocks: [
        { h3: '6.1 Service areas and delivery estimates' },
        { p: 'PETCHEFY delivers only to locations shown as eligible through the Services.' },
        { p: 'Available delivery methods, carriers, delivery dates, pickup options, and delivery fees may vary based on the address and order.' },
        { p: 'Delivery dates and windows are estimates unless PETCHEFY expressly guarantees a particular delivery time in writing. Weather, traffic, carrier interruptions, building access, supply disruptions, and other circumstances may affect delivery.' },
        { h3: '6.2 Accurate delivery information' },
        { p: 'You are responsible for providing a complete and accurate:' },
        { ul: [
          'Delivery address;',
          'Apartment or unit number;',
          'Gate or building-access code;',
          'Delivery instruction;',
          'Telephone number; and',
          'Other information reasonably needed to complete delivery.'
        ] },
        { p: 'You authorize PETCHEFY and its delivery providers to leave an order at the address or designated delivery location you provide when unattended delivery is permitted.' },
        { p: 'PETCHEFY is not responsible for a failed or delayed delivery to the extent it was caused by an inaccurate address, inaccessible premises, missing access instructions, or another customer-controlled issue.' },
        { h3: '6.3 Retrieval and storage' },
        { p: 'PETCHEFY products are fresh and perishable.' },
        { p: 'You are responsible for promptly retrieving, inspecting, refrigerating, freezing, thawing, handling, and serving the food in accordance with the instructions provided with the product.' },
        { p: 'Responsibility for prompt retrieval and proper storage passes to you after the order has been properly delivered to the location you designated. This does not limit PETCHEFY’s responsibility for misdelivery, pre-delivery damage, contamination, or another obligation that cannot legally be excluded.' },
        { p: 'Do not feed a product if:' },
        { ul: [
          'The packaging is open, leaking, swollen, or materially damaged;',
          'The product has an unexpected odor or appearance;',
          'The food appears to have been held at an unsafe temperature; or',
          'You otherwise reasonably believe the product may be unsafe.'
        ] },
        { p: 'Contact {email}' + EMAIL + '{/} or {sms}text ' + PHONE + '{/} as soon as reasonably possible. Include the order number, delivery date, photographs, and batch or lot information when available.' },
        { h3: '6.4 Pickup orders' },
        { p: 'Pickup orders must be collected during the stated pickup window.' },
        { p: 'After pickup, you are responsible for safely transporting, handling, and storing the food.' },
        { p: 'Contact PETCHEFY promptly if you cannot collect the order as scheduled. PETCHEFY does not guarantee that a missed pickup can be rescheduled or refunded.' },
        { h3: '6.5 Delays outside PETCHEFY’s control' },
        { p: 'PETCHEFY is not responsible for delays caused by circumstances reasonably outside its control.' },
        { p: 'If an affected order cannot be safely or reasonably fulfilled, PETCHEFY may reschedule it, replace it, issue an account credit, or cancel and refund the unfulfilled portion.' }
      ]
    },
    {
      n: '7', id: 'refunds', title: 'Returns, Refunds, Credits, and Replacements',
      blocks: [
        { p: 'PETCHEFY’s complete refund terms are available in the {refund}PETCHEFY Refund Policy{/}.' },
        { h3: '7.1 No physical returns' },
        { p: 'Because PETCHEFY meals are fresh and perishable, PETCHEFY does not accept physical returns. Food that has left PETCHEFY’s control cannot be safely restocked or resold.' },
        { h3: '7.2 First-order satisfaction policy' },
        { call: [
          'If your first PETCHEFY order does not work for you or your dog, contact {email}' + EMAIL + '{/} within <b>30 days</b> after receiving it.'
        ] },
        { p: 'PETCHEFY may first work with you to adjust the recipe, portion, feeding schedule, or meal plan. If the issue cannot reasonably be resolved, PETCHEFY will issue a full refund for the first order in accordance with the Refund Policy.' },
        { p: 'A refund request does not automatically cancel a subscription unless you also clearly request cancellation. Any clear statement that you want future recurring orders stopped will be treated as a cancellation request.' },
        { h3: '7.3 Processed recurring orders' },
        { p: 'Once a recurring order has processed, it cannot be canceled.' },
        { p: 'Whether a processed order qualifies for a refund, credit, replacement, or other remedy is determined under the Refund Policy.' },
        { p: 'Late cancellation by itself does not create a right to a refund for a processed recurring order.' },
        { h3: '7.4 PETCHEFY or delivery errors' },
        { p: 'If an order is incorrect, materially damaged, missing, unsafe, or affected by a verified PETCHEFY or delivery error, contact us promptly.' },
        { p: 'Depending on the circumstances, PETCHEFY may provide a replacement, redelivery, account credit, discount, partial refund, or full refund.' },
        { p: 'Refunds are ordinarily issued to the original payment method. Your bank or payment provider may require additional time to post the refund.' },
        { p: 'Nothing in these Terms limits a consumer right or remedy that cannot legally be waived.' }
      ]
    },
    {
      n: '8', id: 'safety', title: 'Food-Safety Notices and Recalls',
      blocks: [
        { p: 'PETCHEFY may contact you regarding a product withdrawal, recall, safety investigation, recipe issue, or handling concern.' },
        { p: 'You agree to follow reasonable safety instructions, including instructions to:' },
        { ul: [
          'Stop feeding a product;',
          'Preserve packaging, batch, or lot information;',
          'Refrigerate, freeze, or discard affected food; or',
          'Provide information concerning the product’s condition.'
        ] },
        { p: 'If you believe a PETCHEFY product may have caused an illness or injury, stop feeding it, obtain appropriate veterinary care, preserve the packaging and remaining product when safe to do so, and contact PETCHEFY promptly.' }
      ]
    },
    {
      n: '9', id: 'promotions', title: 'Promotions, Discounts, and Referral Offers',
      blocks: [
        { p: 'Promotions, introductory offers, discounts, referral credits, samples, trials, and giveaways may be governed by separate offer terms.' },
        { p: 'Unless the applicable offer expressly states otherwise, promotional offers:' },
        { ul: [
          'Apply only during the stated promotional period;',
          'Are limited to one per eligible customer or household;',
          'Have no cash value;',
          'Cannot be transferred or resold;',
          'Cannot be combined with other offers;',
          'Apply only to the specified products or billing periods; and',
          'May be withheld or revoked in cases of fraud, duplicate accounts, chargeback abuse, reversed qualifying transactions, or material error.'
        ] },
        { p: 'A promotional subscription price may automatically change to the regular subscription price after the disclosed promotional period.' }
      ]
    },
    {
      n: '10', id: 'communications', title: 'Communications',
      blocks: [
        { p: 'PETCHEFY may send transactional emails, telephone calls, or text messages concerning your:' },
        { ul: [
          'Account;',
          'Order;',
          'Payment;',
          'Subscription;',
          'Delivery;',
          'Food-safety matter; or',
          'Customer-support request.'
        ] },
        { p: 'Marketing-email consent may be withdrawn by using the unsubscribe link contained in the email.' },
        { p: 'PETCHEFY will send automated or marketing text messages only with the consent required by law. Consent to receive marketing text messages is not a condition of purchase. Message and data rates may apply.' },
        { p: 'Replying STOP to an automated marketing text opts you out of marketing texts. It does not by itself cancel a food subscription unless your message also clearly asks PETCHEFY to cancel or stop the subscription.' },
        { call: [
          'To cancel a subscription by text, send an unambiguous message such as “Cancel my PETCHEFY subscription” to {sms}' + PHONE + '{/}. Similar wording that clearly communicates the same request will be honored.'
        ] }
      ]
    },
    {
      n: '11', id: 'reviews', title: 'Reviews and Other Customer Content',
      blocks: [
        { p: 'You may submit reviews, comments, photographs, videos, testimonials, suggestions, pet information, and other content to PETCHEFY (“Customer Content”).' },
        { p: 'You retain ownership of your Customer Content.' },
        { p: 'By submitting Customer Content, you grant PETCHEFY a nonexclusive, worldwide, royalty-free, sublicensable license to host, reproduce, display, format, distribute, and use that content to operate, improve, advertise, and promote PETCHEFY and the Services, subject to the {privacy}Privacy Policy{/} and any separate written agreement.' },
        { p: 'You represent that:' },
        { ul: [
          'You own the content or have permission to submit it;',
          'The content is truthful and reflects your genuine experience;',
          'The content does not violate another person’s intellectual-property, privacy, publicity, or other rights;',
          'The content does not disclose another person’s confidential information; and',
          'The content is not unlawful, fraudulent, threatening, defamatory, obscene, or malicious.'
        ] },
        { p: 'PETCHEFY may decline, edit, or remove Customer Content that violates these Terms.' },
        { p: 'General ideas, suggestions, and feedback may be used without compensation or a confidentiality obligation unless PETCHEFY agrees otherwise in writing.' }
      ]
    },
    {
      n: '12', id: 'ip', title: 'Intellectual Property and Acceptable Use',
      blocks: [
        { p: 'The Services and their content—including text, photographs, graphics, product descriptions, recipe expressions, designs, software, videos, logos, trademarks, and layouts—are owned by PETCHEFY or its licensors and are protected by applicable intellectual-property laws.' },
        { p: 'PETCHEFY grants you a limited, revocable, nonexclusive, nontransferable right to access and use the Services for personal and lawful purposes.' },
        { p: 'You may not:' },
        { ul: [
          'Reproduce, publish, distribute, sell, or commercially exploit Service content without written permission;',
          'Use PETCHEFY trademarks or branding in a misleading manner;',
          'Scrape, crawl, harvest, or extract data through unauthorized automated means;',
          'Reverse engineer or interfere with the Services;',
          'Circumvent security or access controls;',
          'Introduce viruses, malware, or other harmful code;',
          'Impersonate another person;',
          'Submit false, fraudulent, or misleading information;',
          'Use the Services for unlawful activity or unauthorized resale; or',
          'Interfere with another person’s use of the Services.'
        ] },
        { p: 'PETCHEFY may restrict or terminate access when it reasonably believes these restrictions have been violated.' }
      ]
    },
    {
      n: '13', id: 'third-party', title: 'Third-Party Services',
      blocks: [
        { p: 'The Services may rely on third-party providers, including Shopify, payment processors, carriers, delivery providers, mapping services, analytics providers, customer-support services, and social-media platforms.' },
        { p: 'Those services may be governed by their own terms and privacy policies.' },
        { p: 'PETCHEFY is not responsible for independent third-party content or conduct outside its reasonable control, except to the extent liability cannot legally be excluded.' },
        { p: 'The inclusion of a third-party link or integration does not necessarily constitute PETCHEFY’s endorsement of that third party.' }
      ]
    },
    {
      n: '14', id: 'disclaimers', title: 'Disclaimers',
      blocks: [
        { p: 'Except for express statements in these Terms, the Refund Policy, an applicable product label, or another written warranty—and except as required by law—the website and online portions of the Services are provided on an “as is” and “as available” basis.' },
        { p: 'PETCHEFY does not guarantee that the website will always be uninterrupted, secure, error-free, or compatible with every device.' },
        { p: 'PETCHEFY does not guarantee that:' },
        { ul: [
          'Every product will always be available;',
          'Delivery will always occur within an estimated window;',
          'A particular dog will accept or tolerate a product;',
          'A meal plan will eliminate the need for veterinary care; or',
          'A customer or dog will obtain a particular result.'
        ] },
        { p: 'Nothing in these Terms disclaims a product-safety obligation, express warranty, or consumer right that cannot legally be disclaimed.' }
      ]
    },
    {
      n: '15', id: 'liability', title: 'Limitation of Liability',
      blocks: [
        { p: 'To the maximum extent permitted by law, PETCHEFY and its officers, employees, contractors, and affiliates will not be liable for indirect, incidental, special, exemplary, punitive, or consequential damages, including lost profits, lost business, or lost data, arising from the website or Services.' },
        { p: 'For claims other than claims arising from a defective or contaminated product, personal injury, pet injury caused by PETCHEFY’s negligence, fraud, gross negligence, willful misconduct, or a right that cannot legally be limited, PETCHEFY’s total aggregate liability will not exceed the greater of:' },
        { ul: [
          'One hundred dollars; or',
          'The amount you paid PETCHEFY during the 12 months immediately preceding the event giving rise to the claim.'
        ] },
        { p: 'PETCHEFY is not responsible for loss or injury to the extent caused by:' },
        { ul: [
          'Materially inaccurate information supplied by you;',
          'Failure to disclose a known allergy or medical condition;',
          'Disregard of feeding, handling, or storage instructions;',
          'Improper handling after delivery or pickup;',
          'Unauthorized alteration or relabeling of a product; or',
          'Another act or omission outside PETCHEFY’s reasonable control.'
        ] },
        { p: 'Some jurisdictions do not permit certain warranty exclusions or liability limitations. In those jurisdictions, these provisions apply only to the maximum extent permitted by law.' }
      ]
    },
    {
      n: '16', id: 'indemnification', title: 'Indemnification',
      blocks: [
        { p: 'To the extent permitted by law, you agree to defend, indemnify, and hold harmless PETCHEFY and its officers, employees, contractors, and affiliates from third-party claims, liabilities, damages, and reasonable legal expenses arising from:' },
        { ul: [
          'Your unlawful or unauthorized use of the Services;',
          'Your unauthorized resale, relabeling, alteration, or distribution of a product;',
          'Customer Content submitted by you;',
          'Your violation of another person’s rights; or',
          'Your material breach of these Terms.'
        ] },
        { p: 'This obligation does not apply to the extent a claim was caused by PETCHEFY’s negligence, defective product, violation of law, or willful misconduct.' }
      ]
    },
    {
      n: '17', id: 'termination', title: 'Suspension and Termination',
      blocks: [
        { p: 'You may stop using the Services at any time.' },
        { call: [
          'Stopping use of the website does not cancel an active subscription. A subscription must be canceled using one of the methods described in {s5}Section 5{/}.'
        ] },
        { p: 'PETCHEFY may suspend or terminate an account, refuse an order, or restrict access when it reasonably believes there has been:' },
        { ul: [
          'Fraud;',
          'Payment or chargeback abuse;',
          'Unauthorized resale;',
          'Unlawful conduct;',
          'A security threat; or',
          'A material breach of these Terms.'
        ] },
        { p: 'Termination does not eliminate payment obligations for properly processed or fulfilled orders or rights and obligations that arose before termination.' },
        { p: 'If PETCHEFY cancels an unfulfilled paid order for reasons unrelated to your breach, PETCHEFY will refund the affected unfulfilled amount.' }
      ]
    },
    {
      n: '18', id: 'changes', title: 'Changes to the Services or These Terms',
      blocks: [
        { p: 'PETCHEFY may change product availability, recipes, delivery methods, account features, and other aspects of the Services.' },
        { p: 'A change will not eliminate PETCHEFY’s obligation to fulfill, replace, credit, or refund an existing paid order as required under these Terms or applicable law.' },
        { p: 'PETCHEFY may update these Terms prospectively. Updated Terms will display a revised effective date.' },
        { p: 'PETCHEFY will provide reasonable notice of a material change through the website, email, text, customer account, or another reasonable method.' },
        { p: 'Changes will not apply retroactively to a dispute that arose before the updated Terms became effective.' },
        { p: 'When required by law, PETCHEFY will obtain additional consent before applying a material change to an existing subscription.' },
        { p: 'Your continued use of the Services after the effective date of properly disclosed updated Terms constitutes acceptance of those Terms.' }
      ]
    },
    {
      n: '19', id: 'disputes', title: 'Disputes and Governing Law',
      blocks: [
        { p: 'Before filing a legal claim, you and PETCHEFY agree to make a reasonable, good-faith effort to resolve the dispute informally.' },
        { p: 'Send a written description of the dispute and requested resolution to {email}' + EMAIL + '{/} with the subject line “Legal Notice,” or mail it to the address in {s21}Section 21{/}.' },
        { p: 'PETCHEFY will have 30 days after receiving the notice to attempt to resolve the matter.' },
        { p: 'These Terms are governed by the laws of the State of Florida and applicable federal law, without regard to conflict-of-law principles.' },
        { p: 'Subject to any consumer right that cannot be waived, legal proceedings must be brought in the state or federal courts located in Miami-Dade County, Florida.' },
        { p: 'Either party may bring an eligible matter in small-claims court. Either party may also seek temporary or emergency relief to prevent misuse of intellectual property, confidential information, or computer systems.' },
        { p: 'Nothing in this section prevents a consumer from exercising a right to bring a claim in another location when applicable law does not permit that right to be waived.' }
      ]
    },
    {
      n: '20', id: 'general', title: 'General Provisions',
      blocks: [
        { h3: 'Force majeure' },
        { p: 'PETCHEFY is not responsible for a delay caused by severe weather, natural disaster, fire, utility failure, epidemic, government action, labor disruption, transportation interruption, supplier interruption, cyberattack, or another event reasonably outside its control.' },
        { p: 'This provision does not allow PETCHEFY to retain payment for an order that PETCHEFY permanently cancels and never fulfills.' },
        { h3: 'Assignment' },
        { p: 'You may not assign these Terms without PETCHEFY’s written permission.' },
        { p: 'PETCHEFY may assign these Terms in connection with a merger, financing, acquisition, reorganization, or sale of all or substantially all relevant business assets, subject to applicable notice requirements.' },
        { h3: 'Severability' },
        { p: 'If a provision of these Terms is found invalid or unenforceable, it will be enforced to the maximum lawful extent or severed. The remaining provisions will continue in effect.' },
        { h3: 'Waiver' },
        { p: 'A failure to enforce a provision is not a waiver of that provision or any other right.' },
        { h3: 'Entire agreement' },
        { p: 'These Terms, applicable checkout disclosures, the Privacy Policy, the Refund Policy, and product-, order-, or promotion-specific terms constitute the entire agreement regarding the Services.' },
        { h3: 'Electronic records' },
        { p: 'You consent to receive these Terms, order confirmations, subscription notices, disclosures, and other records electronically.' },
        { p: 'Electronic records and electronic acceptance have the same effect as paper records and handwritten signatures to the extent permitted by law.' },
        { h3: 'No third-party beneficiaries' },
        { p: 'Except as expressly stated, these Terms do not create rights for anyone other than you and PETCHEFY.' },
        { h3: 'Survival' },
        { p: 'Provisions that by their nature should survive termination—including payment obligations, intellectual-property provisions, disclaimers, limitations of liability, indemnification, and dispute provisions—will survive.' }
      ]
    },
    {
      n: '21', id: 'contact', title: 'Contact Information',
      blocks: [
        { address: true },
        { rows: true }
      ]
    }
  ];

  /* ============================== render ============================== */

  var LINK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7"/><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7"/></svg>';
  var PHONE_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>';
  var MAIL_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-10 6L2 7"/></svg>';

  function contactRows() {
    return '<div class="terms2-contactrows">' +
      '<a class="terms2-crow" href="' + SMS + '">' + PHONE_ICON + '<span><span class="l">Text</span><br>' + esc(PHONE) + '</span></a>' +
      '<a class="terms2-crow" href="mailto:' + esc(EMAIL) + '">' + MAIL_ICON + '<span><span class="l">Email</span><br>' + esc(EMAIL) + '</span></a>' +
      '</div>';
  }

  function addressCard() {
    return '<div class="terms2-address">' +
      '<div class="terms2-address-l">Registered entity</div>' +
      '<p>PET CHEFY LLC</p>' +
      '<p class="sm">Florida Document Number: L22000431585</p>' +
      '<p class="sm">995 NW 21st Terrace<br>Miami, Florida 33127</p>' +
      '<p class="sm">Website: <a href="https://petchefy.com" style="color:inherit;">petchefy.com</a></p>' +
      '</div>';
  }

  function renderBlocks(blocks) {
    return blocks.map(function (b) {
      if (b.p) return '<p>' + links(b.p) + '</p>';
      if (b.h3) return '<h3 class="terms2-h3">' + esc(b.h3) + '</h3>';
      if (b.ul) return '<ul>' + b.ul.map(function (li) { return '<li>' + links(li) + '</li>'; }).join('') + '</ul>';
      if (b.call) return '<div class="terms2-call">' + b.call.map(function (p) { return '<p>' + links(p) + '</p>'; }).join('') + '</div>';
      if (b.rows) return contactRows();
      if (b.address) return addressCard();
      return '';
    }).join('');
  }

  function sTopbar() {
    return '<header class="terms2-topbar" data-topbar>' +
      '<a class="terms2-topbar-phone" href="' + TEL + '" aria-label="Call or text PETCHEFY at ' + esc(PHONE) + '">' +
      PHONE_ICON + '<span>' + esc(PHONE) + '</span></a>' +
      (LOGO ? '<img class="terms2-topbar-logo" src="' + esc(LOGO) + '" alt="PETCHEFY">' : '<b class="terms2-topbar-logo" style="filter:none;color:#fff;letter-spacing:.24em;">PETCHEFY</b>') +
      '<a class="terms2-topbar-login" href="' + esc(LOGIN_URL) + '">Log In</a>' +
      '</header>' +
      '<div class="terms2-progress" data-progresswrap><div class="terms2-progress-fill" data-progress></div></div>';
  }

  function sHero() {
    /* No kicker or standfirst: the scope of the agreement is stated in §1 ("a legally
       binding agreement between you and PET CHEFY LLC" + the list of covered Services),
       and the support number is in the topbar, §5.2, §6.3, §10, §21, the CTA band and
       the footer — a hero summary would only restate them. */
    return '<section class="terms2-hero terms2-dark"><div class="terms2-wrap terms2-hero-inner">' +
      '<h1>Terms &amp; <span class="terms2-u">Conditions</span></h1>' +
      '<div class="terms2-meta">' +
      '<span class="terms2-badge"><span class="dot"></span>Effective <b>' + esc(EFFECTIVE) + '</b></span>' +
      '<span class="terms2-badge">' + SECTIONS.length + ' sections</span>' +
      '<span class="terms2-badge">Governed by Florida law</span>' +
      '</div>' +
      '</div></section>';
  }

  /* NOTE: the docx opens with a standalone "Important Autoship Notice" summarising
     auto-renewal and the cancellation cutoff. That block is not rendered as its own
     banner — every statement in it is already stated in the agreement body at §5.1
     (auto-renewal at the checkout price/frequency until cancelled), §5.2 (cancel by
     text, email, or the customer account, with the contact details), and §5.3 (the
     before-processing cutoff; a processed order cannot be cancelled and later orders
     stop). Verified by qa/terms-v2-integrity.js. */

  function sBody() {
    var toc = SECTIONS.map(function (s) {
      return '<li class="terms2-toc-li" data-tocli data-id="' + s.id + '">' +
        '<button class="terms2-toc-a" type="button" data-toc="' + s.id + '">' +
        '<span class="n">' + s.n + '</span><span class="t">' + esc(s.title) + '</span></button></li>';
    }).join('');

    var secs = SECTIONS.map(function (s) {
      return '<section class="terms2-sec" id="' + s.id + '" data-sec="' + s.id + '">' +
        '<div class="terms2-sec-head"><span class="terms2-sec-n">' + s.n + '</span>' +
        '<h2 class="terms2-sec-t">' + esc(s.title) + '</h2></div>' +
        '<hr class="terms2-sec-rule">' +
        renderBlocks(s.blocks) +
        '<button class="terms2-copylink" type="button" data-copylink="' + s.id + '">' + LINK_ICON + '<span>Copy link</span></button>' +
        '</section>';
    }).join('');

    return '<div class="terms2-body"><div class="terms2-wrap terms2-shell">' +
      '<div class="terms2-tocwrap">' +
      '<div class="terms2-tocbar">' +
      '<button class="terms2-toctoggle" type="button" data-toctoggle aria-expanded="false">' +
      '<span>Contents</span><span class="cur" data-toccur>1. Agreement to These Terms</span>' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>' +
      '</button>' +
      '<nav class="terms2-toc" aria-label="Table of contents">' +
      '<div class="terms2-toc-l">On this page</div>' +
      '<div class="terms2-toc-search" data-searchwrap>' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>' +
      '<input type="search" data-search placeholder="Search these terms" aria-label="Search the terms" autocomplete="off">' +
      '<button class="terms2-toc-clear" type="button" data-search-clear aria-label="Clear search">✕</button>' +
      '</div>' +
      '<ul class="terms2-toc-list">' + toc + '</ul>' +
      '<p class="terms2-toc-empty">No section matches that search.</p>' +
      '</nav></div></div>' +
      '<div class="terms2-content">' + secs + '</div>' +
      '</div></div>';
  }

  function sCta() {
    return '<section class="terms2-cta terms2-dark"><div class="terms2-wrap terms2-cta-inner">' +
      '<span class="terms2-cta-hand">questions about the fine print?</span>' +
      '<h2>Talk to a real person.</h2>' +
      '<p class="terms2-cta-sub">Cancel, skip, or ask anything — text us and you’ll get Andres, Jeff, or someone who knows your dog’s name.</p>' +
      '<div class="terms2-cta-btns">' +
      '<a class="terms2-btn" href="' + SMS + '">Text ' + esc(PHONE) + '</a>' +
      '<a class="terms2-btn terms2-btn--ghost" href="mailto:' + esc(EMAIL) + '">Email us</a>' +
      '</div>' +
      '<p class="terms2-cta-note">See also: <a href="' + esc(FAQ_URL) + '">FAQ</a> · <a href="' + esc(REFUND_URL) + '">Refund Policy</a> · <a href="' + esc(PRIVACY_URL) + '">Privacy Policy</a></p>' +
      '</div></section>';
  }

  function sFooter() {
    return '<footer class="terms2-footer"><div class="terms2-wrap">' +
      '<div class="terms2-footer-grid">' +
      '<div><div class="terms2-footer-h">Get Support <span class="it">Available 24/7</span></div>' +
      '<div class="terms2-footer-line">' + esc(EMAIL) + '</div>' +
      '<div class="terms2-footer-line">' + esc(PHONE) + ' – Call or Text</div></div>' +
      '<div><div class="terms2-footer-h">Connect</div>' +
      '<div class="terms2-footer-social">' +
      '<a href="' + SOCIAL.instagram + '" target="_blank" rel="noopener">Instagram</a>' +
      '<a href="' + SOCIAL.facebook + '" target="_blank" rel="noopener">Facebook</a>' +
      '<a href="' + SOCIAL.tiktok + '" target="_blank" rel="noopener">TikTok</a></div></div>' +
      '<div><div class="terms2-footer-h">Feed them fresh</div>' +
      '<div class="terms2-footer-line"><a href="' + esc(CTA_URL) + '" style="color:#fff;text-decoration:underline;text-underline-offset:3px;">Build your dog’s plan →</a></div></div>' +
      '</div>' +
      '<hr class="terms2-footer-rule">' +
      '<div class="terms2-footer-legal">© 2026 PETCHEFY, Inc.<div class="terms2-footer-tm">Give your pup a healthy life™</div></div>' +
      '</div></footer>';
  }

  function sTop() {
    return '<button class="terms2-top" type="button" data-top aria-label="Back to top">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="m18 15-6-6-6 6"/></svg></button>';
  }

  root.innerHTML = sTopbar() + sHero() + sBody() + sCta() + sFooter() + sTop();

  /* ============================== bindings ============================== */

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = reduceMotion ? 'auto' : 'smooth';

  /* topbar hairline + progress bar + back-to-top */
  var topbar = root.querySelector('[data-topbar]');
  var progressWrap = root.querySelector('[data-progresswrap]');
  var progress = root.querySelector('[data-progress]');
  var topBtn = root.querySelector('[data-top]');
  var bodyEl = root.querySelector('.terms2-body');

  function positionProgress() {
    progressWrap.style.top = topbar.offsetHeight + 'px';
  }
  function onScroll() {
    topbar.classList.toggle('is-scrolled', window.scrollY > 8);
    var docH = document.documentElement.scrollHeight - window.innerHeight;
    var p = docH > 0 ? Math.min(1, Math.max(0, window.scrollY / docH)) : 0;
    progress.style.width = (p * 100) + '%';
    topBtn.classList.toggle('is-on', window.scrollY > window.innerHeight * 0.9);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { positionProgress(); onScroll(); });
  positionProgress();
  onScroll();

  topBtn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: behavior });
  });

  /* mobile TOC toggle */
  var tocToggle = root.querySelector('[data-toctoggle]');
  var tocCur = root.querySelector('[data-toccur]');
  function closeToc() {
    root.classList.remove('toc-open');
    tocToggle.setAttribute('aria-expanded', 'false');
  }
  tocToggle.addEventListener('click', function () {
    var open = !root.classList.contains('toc-open');
    root.classList.toggle('toc-open', open);
    tocToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* TOC nav + scrollspy */
  var tocBtns = [].slice.call(root.querySelectorAll('[data-toc]'));
  var secs = [].slice.call(root.querySelectorAll('[data-sec]'));

  function setActive(id) {
    var meta = null;
    tocBtns.forEach(function (b) {
      var on = b.getAttribute('data-toc') === id;
      b.classList.toggle('is-on', on);
      if (on) {
        meta = b;
        /* keep the active entry visible inside the scrolling sidebar */
        var list = b.closest('.terms2-toc');
        if (list && list.scrollHeight > list.clientHeight) {
          var bTop = b.offsetTop, bBot = bTop + b.offsetHeight;
          if (bTop < list.scrollTop || bBot > list.scrollTop + list.clientHeight) {
            list.scrollTop = bTop - list.clientHeight / 2 + b.offsetHeight / 2;
          }
        }
      }
    });
    if (meta && tocCur) {
      tocCur.textContent = meta.querySelector('.n').textContent + '. ' + meta.querySelector('.t').textContent;
    }
  }

  function spy() {
    var anchor = window.innerHeight * 0.28;
    var current = secs.length ? secs[0].getAttribute('data-sec') : null;
    secs.forEach(function (s) {
      if (s.getBoundingClientRect().top <= anchor) current = s.getAttribute('data-sec');
    });
    if (current) setActive(current);
  }
  window.addEventListener('scroll', spy, { passive: true });

  function jumpTo(id) {
    var target = document.getElementById(id);
    if (!target) return;
    closeToc();
    target.scrollIntoView({ behavior: behavior, block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  }
  tocBtns.forEach(function (b) {
    b.addEventListener('click', function () { jumpTo(b.getAttribute('data-toc')); });
  });
  /* in-copy cross references ({s5}/{s21}) */
  [].slice.call(root.querySelectorAll('[data-jump]')).forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); jumpTo(a.getAttribute('data-jump')); });
  });

  /* copy link */
  [].slice.call(root.querySelectorAll('[data-copylink]')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = location.origin + location.pathname + location.search + '#' + btn.getAttribute('data-copylink');
      function done() {
        btn.classList.add('is-copied');
        btn.querySelector('span').textContent = 'Copied ✓';
        setTimeout(function () {
          btn.classList.remove('is-copied');
          btn.querySelector('span').textContent = 'Copy link';
        }, 1800);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, done);
      } else { done(); }
    });
  });

  /* search: filter the TOC + highlight matches in the body (never hides legal text) */
  var searchInput = root.querySelector('[data-search]');
  var searchWrap = root.querySelector('[data-searchwrap]');
  var tocLis = [].slice.call(root.querySelectorAll('[data-tocli]'));
  var contentEl = root.querySelector('.terms2-content');
  var secText = {};
  secs.forEach(function (s) { secText[s.getAttribute('data-sec')] = s.textContent.toLowerCase(); });

  function clearMarks() {
    [].slice.call(contentEl.querySelectorAll('mark[data-t2mark]')).forEach(function (m) {
      var parent = m.parentNode;
      if (!parent) return;
      parent.replaceChild(document.createTextNode(m.textContent), m);
      parent.normalize();
    });
  }

  function markTerm(term) {
    var walker = document.createTreeWalker(contentEl, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (node) {
      var txt = node.nodeValue;
      var low = txt.toLowerCase();
      var idx = low.indexOf(term);
      if (idx < 0) return;
      var frag = document.createDocumentFragment();
      var last = 0;
      while (idx >= 0) {
        if (idx > last) frag.appendChild(document.createTextNode(txt.slice(last, idx)));
        var mk = document.createElement('mark');
        mk.setAttribute('data-t2mark', '');
        mk.textContent = txt.slice(idx, idx + term.length);
        frag.appendChild(mk);
        last = idx + term.length;
        idx = low.indexOf(term, last);
      }
      if (last < txt.length) frag.appendChild(document.createTextNode(txt.slice(last)));
      if (node.parentNode) node.parentNode.replaceChild(frag, node);
    });
  }

  function applySearch() {
    var term = searchInput.value.trim().toLowerCase();
    searchWrap.classList.toggle('has-q', !!term);
    clearMarks();
    if (!term || term.length < 2) {
      tocLis.forEach(function (li) { li.classList.remove('is-hidden'); });
      root.classList.remove('toc-noresults');
      return;
    }
    var hits = 0;
    tocLis.forEach(function (li) {
      var id = li.getAttribute('data-id');
      var hit = (secText[id] || '').indexOf(term) >= 0;
      li.classList.toggle('is-hidden', !hit);
      if (hit) hits++;
    });
    root.classList.toggle('toc-noresults', hits === 0);
    markTerm(term);
  }
  var debounce;
  searchInput.addEventListener('input', function () {
    clearTimeout(debounce);
    debounce = setTimeout(applySearch, 140);
  });
  root.querySelector('[data-search-clear]').addEventListener('click', function () {
    searchInput.value = '';
    applySearch();
    searchInput.focus();
  });

  /* deep link on load (#autoship etc.) */
  (function handleHash() {
    var id = (location.hash || '').replace('#', '');
    if (id && document.getElementById(id)) {
      setTimeout(function () { document.getElementById(id).scrollIntoView({ behavior: 'auto', block: 'start' }); }, 60);
    }
  })();
  window.addEventListener('hashchange', function () {
    var id = (location.hash || '').replace('#', '');
    if (id && document.getElementById(id)) jumpTo(id);
  });

  spy();
})();
